import React, { useState, useEffect, useMemo } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import * as yup from "yup";
import { connect, useSelector, useDispatch } from "react-redux";
import {
  addButtonModalClose,
  addButtonModalOpen,
} from "../../actions/addButton";
import {
  cancelActivity,
  doneActivity,
  insertActivity,
  updateActivity,
} from "../../actions/addActivity";
import { addButtonFormService, updateButtonService } from "../../services/api";
import { useTranslation } from "react-i18next";

import SwitchOption from "./SwitchOption";

import ButtonStylesBulma from "./ButtonStylesBulma";

import SearchButton from "../SubComponents/SearchBar/SearchButton";
import { pullVideosFromPixabay } from "../../actions/pixabayVideo";
import { closePixabay } from "../../actions/pixabay";
import PixabayIcon from "../../assets/img/pixabay3.png";
import PixabayForm from "../PixabayVideoForm";

import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import ReactPlayer from "react-player";
import { confirmAlert } from "react-confirm-alert";
import { MdPublic } from "react-icons/md";

import "react-tabs/style/react-tabs.css";

import "react-quill/dist/quill.snow.css";
import { guidGenerator, parseBoolean } from "../../services/util";
import AddNoteGif from "../../assets/img/gif/addNote.gif";

import Uppy from "@uppy/core";
// import Tus from "@uppy/tus";
import { DragDrop } from "@uppy/react";

import "@uppy/core/dist/style.css";
import "@uppy/drag-drop/dist/style.css";
import {
  selectCurrentPageId,
  selectMergedButtonsForCurrentPage,
  selectMyContent,
} from "../../store/configureStore";

// import modalCloseBtn from "../../assets/img/svg/modal-close-btn.svg";

function VideoForm(props) {
  const { t } = useTranslation();
  const domain = useSelector((state) => state.login.user_profile.domain_name);
  const dispatch = useDispatch();
  const activityId = useSelector((state) => state.activities.activityId);
  const activityType = useSelector((state) => state.activities.activityName);
  const activityLeft = useSelector((state) => state.activities.activityLeft);
  const activityTop = useSelector((state) => state.activities.activityTop);
  const activityBtnStyle = useSelector(
    (state) => state.activities.activityBtnStyle
  );
  const activityShow = useSelector((state) => state.activities.activityShow);

  !activityType && props.addButtonModalClose();
  !activityType && props.cancelActivity();

  //   const [loader, setLoader] = useState(false);
  const [buttonStyle, setButtonStyle] = useState("style1");
  const [isPublic, setIsPublic] = useState(false);
  // const [fileName, setFileName] = useState(true);
  const [visible, setVisible] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  //   const [buttonStyle, setButtonStyle] = useState("style1");

  const [fileName, setFileName] = useState("");

  const [showSources, setShowSources] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [pixabayClicked, setPixabayClicked] = useState(false);
  const [pixabayImage, setPixabayImage] = useState(null);
  const [pixabayImageLoaded, setPixabayImageLoaded] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);

  const handleOnChange = (e) => {
    props.closePixabay();

    if (e.target.value) {
      setShowSources(true);
      setInputValue(e.target.value);
    } else {
      setShowSources(false);
      setInputValue("");
    }
  };

  const pixabayHandler = () => {
    setPixabayClicked(true);
    props.pullVideosFromPixabay(inputValue);
  };

  const pixabayImageHandler = (imageUrl) => {
    setPixabayImage(imageUrl);
    setPixabayImageLoaded(false);

  };

  const [picture, setPicture] = useState(null);
  const onChangePicture = (e) => {

    // if (e.target.files[0]) {
    //   setPicture(URL.createObjectURL(e.target.files[0]));
    // }
  };

  const showContent = () => {
    confirmAlert({ customUI: showContentCustomUI });
  };

  const showContentCustomUI = ({ onClose }) => {
    const handleClickedClose = () => {
      onClose();
    };
    return (
      <section className="hero is-large">
        <div className="hero-body has-text-centered">
          <div className="container">
            <button
              className="button is-danger is-rounded is-bold is-size-4 is-pulled-right pb-0 pt-0 pl-3 pr-3"
              style={{ marginRight: -15, marginTop: -15, height: "auto" }}
              onClick={handleClickedClose}
            >
              X
            </button>
            <div className="box">
              <img src={AddNoteGif} alt="Placeholder image" />
            </div>
          </div>
        </div>
      </section>
    );
  };

  const schema = yup.object().shape({
    // type: yup.string().required(),
    // fileupload: yup
    //   .mixed()
    //   .when("type", {
    //     is: (type) => type == "audio",
    //     then: yup
    //       .mixed()
    //       .test("required", "This Field is Required", (value) => {
    //         return value[0] != undefined;
    //       })
    //       .test("fileSize", "Max 4 MB is allowed", (value) => {
    //         return value && value[0] && value[0].size <= 4000000;
    //       })
    //       .test("type", "Only wav/mp3/aiff is allowed", (value) => {
    //         return (
    //           value &&
    //           value[0] &&
    //           (value[0].name.split(".")[1] == "wav" ||
    //             value[0].name.split(".")[1] == "mp3" ||
    //             value[0].name.split(".")[1] == "aiff")
    //         );
    //       }),
    //   }),
    videoLink: yup.string().required(),
  });

  const { register, handleSubmit, watch, errors, control } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {

    setIsLoading(true);

    const myRatio =
      props.canvasVals.canvasBackgroundImageWidth /
      props.canvasVals.canvasWidth; //ratio of the book page
    const originRatio = 1000 / props.canvasVals.canvasBackgroundImageWidth; //ratio of the book editor - 1000

    const sendData = {
      id: guidGenerator(), //For redux based id generation.
      left: activityId
        ? parseInt(data.left)
        : myRatio * parseInt(data.left) * originRatio, // * props.canvasVals.vpW) / 1000, // -
      top: activityId
        ? parseInt(data.top)
        : myRatio * parseInt(data.top) * originRatio, // * ratio, // - 24,
      height: 24,
      width: 24,
      show: 1,
      button_type: "video",
      own_activity: 1,
      style: buttonStyle,
      status: 1,
      sharing: data.public,
      content: data.videoLink,
      description: data.description,
    };

    // return;
    // activityType === "audio" || activityType === "image"
    //   ? tabIndex === 0
    //     ? formData.append("content", {
    //         uri: sendData.content.uri, /// URL
    //         type: sendData.content.type, /// "url"
    //         name: sendData.content.name, // no empty
    //       })
    //     : formData.append("content", sendData.content)
    //   : formData.append("content", sendData.content);
    if (activityId) {
      const formData = new FormData();
      sendData.left !== parseInt(oldValue.left) &&
        formData.append("left", sendData.left);

      sendData.top !== parseInt(oldValue.top) &&
        formData.append("top", sendData.top);

      // sendData.height !== parseInt(oldValue.height) &&
      //   formData.append("height", sendData.height);

      // sendData.width !== parseInt(oldValue.width) &&
      //   formData.append("width", sendData.width);

      parseBoolean(sendData.show) !== oldValue.show &&
        formData.append("show", sendData.show);

      parseBoolean(sendData.own_activity) !== oldValue.own_activity &&
        formData.append("own_activity", sendData.own_activity);

      sendData.style !== oldValue.style &&
        formData.append("style", sendData.style);

      // sendData.status !== parseInt(oldValue.status) &&
      //   formData.append("status", sendData.status);

      parseBoolean(sendData.sharing) !== oldValue.sharing &&
        formData.append("sharing", sendData.sharing);

      sendData.content !== oldValue.content &&
        formData.append("content", sendData.content);

      sendData.description !== oldValue.description &&
        formData.append("description", sendData.description);


      updateButtonService(formData, String(domain).toLowerCase(), activityId)
        .then(async (response) => {
          sendData.id = response.id;
          sendData.user_id = response.user_id;
          sendData.left = response.left;
          sendData.top = response.top;
          props.addButtonModalClose();
          props.doneActivity();
            props.updateActivity(sendData, response.ebook_pages_id);
          setIsLoading(false);
        })
        .catch((error) => {

          setIsLoading(false);
        });
    } else {
      addButtonFormService(
        sendData,
        String(domain).toLowerCase(),
        props.currentPageId
      )
        .then(async (response) => {
          sendData.id = response.id;
          sendData.user_id = response.user_id;
          if (activityType === "audio" || activityType === "image") {
            sendData.content = response.content;
          }

          props.addButtonModalClose();
          props.doneActivity();
          props.insertActivity(sendData, props.currentPageId);
          setIsLoading(false);
        })
        .catch((error) => {

          setIsLoading(false);
        });
    }
  };

  const selectButtonStyle = (bstyle) => {
    setButtonStyle(bstyle);

  };
  const selectOptionPublic = (opt) => {
    setIsPublic(opt);

  };
  const selectOptionVisible = (opt) => {
    setVisible(opt);

  };

  const uppy = new Uppy({
    meta: { type: "video" },
    restrictions: { maxNumberOfFiles: 1, allowedFileTypes: ["video/*"] },
  });

  // uppy.use(Tus, { endpoint: "/upload" });

  uppy.on("complete", (result) => {


    // store.dispatch({
    //   type: "SET_USER_AVATAR_URL",
    //   payload: { url: url },
    // });
  });

  uppy.on("file-added", (file) => {

    setFileName(file.name);
  });

  const oldValue = activityId
    ? props.myButtons.filter((btn) => btn.id === activityId)[0]
    : null;
  console.log(
    "oldValueVideo",
    activityId,
    oldValue,
    props.myButtons,
    props.myButtons.filter((btn) => btn.id === activityId)
  );
  return (
    <>
      {
        <div className="main-model">
          {/* <label className="label"> */}
          {/* {t(activityType)} */}
          {/* <a
              className="tag is-success has-text-right p-1 ml-2"
              onClick={() => showContent()}
            >
              ?
            </a> */}
          {/* </label> */}

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="w-100">
              <div className="error-message">{errors.fileupload?.message}</div>
              <Tabs defaultIndex={0} onSelect={(index) => setTabIndex(index)}>
                <TabList>
                  {/* <Tab>
                    <span className="is-size-6 m-0">{t("Upload a Video")}</span>
                  </Tab> */}
                  <Tab>
                    <span className="is-size-6 m-0">{t("Video Link")}</span>
                  </Tab>

                  {/* <Tab>
                    <span className="is-size-6 m-0">
                      {t("Pick a Video From Pixabay")}
                    </span>
                  </Tab> */}
                </TabList>

                {/* <TabPanel>
                  <div className="input-group mb-3">
                    <DragDrop
                      uppy={uppy}
                      locale={{
                        strings: {
                          // Text to show on the droppable area.
                          // `%{browse}` is replaced with a link that opens the system file selection dialog.
                          dropHereOr: "Drop here or %{browse}",
                          // Used as the label for the link that opens the system file selection dialog.
                          browse: "browse",
                        },
                      }}
                    />
                    <label className="label" htmlFor="DragDrop">
                      {fileName}
                    </label>
                  </div>
                </TabPanel> */}
                <TabPanel>
                  <div className=" mb-3">
                    <div className="">
                      <div className="field">
                        <span className="tag is-info is-light">
                          {t(
                            "Video Link (Youtube, Vimeo, Facebook, Twitch,SoundCloud, Streamable, Wistia, DailyMotion)"
                          )}
                        </span>
                        <div className="control">
                          <textarea
                            className="textarea is-link"
                            ref={register}
                            name="videoLink"
                            placeholder={
                              t("Please enter a valid link like") +
                              " https://youtu.be/SjiSEvh6fJs"
                            }
                            defaultValue={activityId ? oldValue.content : ""}
                          ></textarea>
                          <div className="error-message">
                            {errors.link?.message}
                          </div>
                        </div>
                      </div>

                      <div className="field">
                        {ReactPlayer.canPlay(
                          watch("videoLink") || oldValue?.content
                        ) ? (
                          <div className="player-wrapper-add-form">
                            <ReactPlayer
                              url={watch("videoLink") || oldValue.content}
                              width="100%"
                              height="50%"
                              controls
                            />
                          </div>
                        ) : (
                          <span>
                            {t("Please enter a valid link like") +
                              " https://youtu.be/SjiSEvh6fJs"}
                          </span>
                        )}
                      </div>
                      <input
                        className="input mt-2"
                        ref={register}
                        defaultValue={
                          activityId ? oldValue.description : t("Video")
                        }
                        type="text"
                        name="description"
                        placeholder={t("Button Name")}
                      />
                    </div>
                  </div>
                </TabPanel>
              </Tabs>
              {/* <hr /> */}
            </div>

            <div className="column box w-100">
              <ButtonStylesBulma
                activityType={activityType}
                selectButtonStyle={selectButtonStyle}
                defaultStyle={activityId ? oldValue.style : "style1"}
              />
            </div>
            <div className="row">
              {/* <div className=""> */}

              {/* <select name="Title" ref={register({ required: true })}>
                  <option value={0}>{t("Private")}</option>
                  <option value={1}>{t("Public")}</option>
                </select> */}
              {/* <SwitchOption
                  activityType={activityType}
                  val1={t("Public")}
                  val2={t("Private")}
                  name="public"
                  ref={register}
                  selectOption={selectOptionPublic}
                  id={1}
                  defaultValue={activityId ? (oldValue.show ? 1 : 0) : 1}
                /> */}
              {/* </div> */}
              <div className="field is-grouped is-grouped-centered w-100">
                <div className="control has-icons-left">
                  <div className="select">
                    <select
                      name="public"
                      ref={register({ required: true })}
                      defaultValue={0}
                    >
                      <option value={0}>{t("Private")}</option>
                      <option value={1}>{t("Public")}</option>
                    </select>
                  </div>
                  <span className="icon is-small is-left">
                    {/* {t("Public")} */}
                    <MdPublic className="fas fa-2x" />
                  </span>
                </div>

                <div className="control has-icons-left has-icons-right">
                  <input
                    className="input"
                    // type="email"
                    placeholder=""
                    defaultValue={parseInt(
                      activityId ? oldValue.top : activityTop
                    )}
                    ref={register}
                    type="text"
                    name="top"
                  />
                  <span className="icon is-small is-left">{t("Top")}</span>
                </div>

                {/*<div className="error-message">field is empty.</div>*/}
                <div className="control has-icons-left has-icons-right">
                  <input
                    className="input"
                    // type="email"
                    placeholder=""
                    defaultValue={parseInt(
                      activityId ? oldValue.left : activityLeft
                    )}
                    ref={register}
                    type="text"
                    name="left"
                  />
                  <span className="icon is-small is-left">{t("Left")}</span>
                </div>
              </div>
            </div>
            {/* <SwitchOption
              activityType={activityType}
              val1={t("Visible")}
              val2={t("Hidden")}
              selectOption={selectOptionVisible}
              id={3}
            /> */}
            <div className="field is-grouped w-100">
              <p className="control">
                <button
                  type="submit"
                  value={t("Submit")}
                  className={`button is-info  ${isLoading ? "is-loading" : ""}`}
                  disabled={isLoading}
                >
                  {t("Submit")}
                </button>
              </p>
              <p className="control">
                <button
                  type="reset"
                  value={t("Cancel")}
                  onClick={props.addButtonModalClose}
                  disabled={isLoading}
                  className={`button is-danger  ${
                    isLoading ? "is-loading" : ""
                  }`}
                >
                  {t("Cancel")}
                </button>
              </p>
            </div>
          </form>
        </div>
      }
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    // currentPageId: state.pages.currentPage[0].id,
    currentPageId: selectCurrentPageId(state),
    canvasScaleX: state.scaleZoomFactor.canvas.scaleX,
    canvasScaleY: state.scaleZoomFactor.canvas.scaleY,
    canvasVals: state.scaleZoomFactor.canvas,
    sideBarOpened: state.sideBarOpened,
    pixabay: state.pixabayVideo,
    // buttons: state.pages.currentPage[0].buttons,
    buttons: selectMergedButtonsForCurrentPage(state),
    myButtons: selectMyContent(state),
  };
};

export default connect(mapStateToProps, {
  addButtonModalOpen,
  addButtonModalClose,
  cancelActivity,
  doneActivity,
  insertActivity,
  updateActivity,
  pullVideosFromPixabay,
  closePixabay,
})(VideoForm);
